import { Component } from '@angular/core';
import { HeaderComponent } from "../../layout/header/header.component";
import { NavbarComponent } from "../../layout/navbar/navbar.component";
import { SidebarComponent } from "../../layout/sidebar/sidebar.component";
import { RoutelinksService } from '../../services/core/routelinks.service';

@Component({
  selector: 'app-enrollment',
  standalone: true,
  imports: [HeaderComponent, NavbarComponent, SidebarComponent],
  templateUrl: './enrollment.component.html',
  styleUrl: './enrollment.component.css'
})
export class EnrollmentComponent {
  links: any[] = [];

  constructor(private routelinks: RoutelinksService) { }

  ngOnInit(): void {
    this.links = this.routelinks.linksEnrollment;
  }
}
